const STORAGE_KEY = "site-migrator-theme";

export type Theme = "light" | "dark";

export function getStoredTheme(): Theme | null {

    if (typeof window === "undefined")
        return null;

    const value = window.localStorage.getItem(STORAGE_KEY);
    return value === "light" || value === "dark" ? value : null;
}

export function getSystemTheme(): Theme {

    if (typeof window === "undefined" || typeof window.matchMedia !== "function")
        return "light";

    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function getTheme(): Theme {

    return getStoredTheme() ?? getSystemTheme();
}

export function applyInitialTheme(): void {

    const theme = getTheme();
    document.documentElement.classList.toggle("dark", theme === "dark");
}

export function setTheme(theme: Theme): void {

    window.localStorage.setItem(STORAGE_KEY, theme);
    document.documentElement.classList.toggle("dark", theme === "dark");
}
